import { CreateNewValues } from "@smartsuite/automation-engine-api";
import {
  Checkbox,
  Paragraph,
  TooltipAdvancedContent,
  TooltipButton,
  Tooltip,
} from "@smartsuite/react-ui/lib";
import type React from "react";
import * as S from "./styles";
import { t } from "i18next";
import { GrayColors } from "@smartsuite/types";

export const CreateNewValuesComponent: React.FC<{
  createNewValues: CreateNewValues;
  onChange: (supportNewValues: CreateNewValues) => void;
  displayPipe?: boolean;
}> = ({ createNewValues, onChange, displayPipe }) => {
  return (
    <S.Wrapper displayPipe={displayPipe}>
      <Paragraph
        size={"xs"}
        styles={{ width: 300, display: "flex", alignItems: "center" }}
      >
        <S.CheckboxSection>
          <Checkbox
            checked={createNewValues === CreateNewValues.YES}
            onChange={(checked) => {
              onChange(checked ? CreateNewValues.YES : CreateNewValues.NO);
            }}
          />
        </S.CheckboxSection>
        <S.CheckboxText
          onClick={() => {
            onChange(
              createNewValues === CreateNewValues.YES
                ? CreateNewValues.NO
                : CreateNewValues.YES,
            );
          }}
        >
          {t("editor.create-new-choices")}
        </S.CheckboxText>

        <Tooltip
          display="inline-flex"
          maxWidth={210}
          padding={2}
          placements={["top"]}
          text={t("editor.create-new-values-tooltip")}
          target={
            <TooltipButton
              iconSize="S"
              iconName="info-filled"
              colors={{
                hover: GrayColors["G-7"],
              }}
            />
          }
          renderTooltipContent={
            <TooltipAdvancedContent
              minWidth={190}
              imageHeight={220}
              paddingType="uniform"
              text={t("editor.create-new-values-tooltip")}
              textSize="xs"
              textWeight="semibold"
            />
          }
        />

        {displayPipe === true && <S.VerticalLine />}
      </Paragraph>
    </S.Wrapper>
  );
};
